import { Link } from "react-router-dom";
import { ROLE_LABELS } from "@velivo/shared";
import { useAuth } from "../auth/AuthContext";

export function SettingsPage() {
  const { user, activeBrand } = useAuth();
  const canCreateBrand = (user?.organizationGrants.length ?? 0) > 0;

  return (
    <>
      <header className="page__header">
        <h1 className="page__title">Settings</h1>
        <p className="page__subtitle">
          Your access, organizations, and brands.
        </p>
      </header>

      <div className="card" style={{ marginBottom: "var(--space-6)" }}>
        <h2
          style={{
            fontSize: "var(--font-h2-size)",
            fontWeight: 600,
            marginBottom: "var(--space-3)",
          }}
        >
          Your access
        </h2>
        <p style={{ color: "var(--color-text-secondary)" }}>
          Signed in as <strong>{user?.email}</strong>
        </p>

        {user?.organizationGrants.map((grant) => (
          <div
            key={grant.organizationId}
            style={{ marginTop: "var(--space-4)" }}
          >
            <strong>{grant.organizationName}</strong>{" "}
            <span className="badge badge--accent">
              {ROLE_LABELS[grant.role]}
            </span>
          </div>
        ))}

        {(user?.brandGrants.length ?? 0) > 0 && (
          <div style={{ marginTop: "var(--space-6)" }}>
            <h3
              style={{
                fontSize: "var(--font-body-size)",
                fontWeight: 600,
                marginBottom: "var(--space-2)",
              }}
            >
              Brands
            </h3>
            <div style={{ overflowX: "auto" }}>
              <table className="table">
                <thead>
                  <tr>
                    <th scope="col">Brand</th>
                    <th scope="col">Your role</th>
                    <th scope="col">Granted</th>
                  </tr>
                </thead>
                <tbody>
                  {user?.brandGrants.map((grant) => (
                    <tr key={grant.brandId}>
                      <td>{grant.brandName}</td>
                      <td>{ROLE_LABELS[grant.role]}</td>
                      <td>
                        <span
                          className={`badge ${grant.inherited ? "badge--info" : "badge--neutral"}`}
                        >
                          {grant.inherited ? "via Organization" : "direct"}
                        </span>
                      </td>
                    </tr>
                  ))}
                </tbody>
              </table>
            </div>
          </div>
        )}
      </div>

      <div className="card">
        <div
          style={{
            display: "flex",
            justifyContent: "space-between",
            alignItems: "center",
            gap: "var(--space-4)",
            flexWrap: "wrap",
          }}
        >
          <div>
            <h2 style={{ fontSize: "var(--font-h2-size)", fontWeight: 600 }}>
              Brands
            </h2>
            <p style={{ color: "var(--color-text-secondary)" }}>
              {canCreateBrand
                ? "Add another company or client to track."
                : "Only an Organization Admin can create Brands."}
            </p>
          </div>
          <div className="page__actions">
            {activeBrand && (
              <Link className="btn btn--secondary" to="/settings/people">
                Manage team
              </Link>
            )}
            {canCreateBrand && (
              <Link className="btn btn--primary" to="/settings/brands/new">
                Create a Brand
              </Link>
            )}
          </div>
        </div>
      </div>
    </>
  );
}
